import { rankWith, schemaMatches } from '@jsonforms/core'

export default rankWith(
  5, // increase rank as needed
  schemaMatches(schema => !schema.properties && schema.type === 'object')
)
